import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/LoadApp-Logo.png';
import { LoaderCircle } from 'lucide-react';
import { requestPasswordReset } from '../../../entities/auth';

export function PasswordResetPage() {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSuccessMessage('Request received! Please check your email to reset your password.');
      setErrorMessage('');
      setEmail('');
    } catch (error) {
      console.error(error);
      setErrorMessage('Failed to send reset email. Please try again.');
      setSuccessMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-md border border-gray-200">
      {/* Logo + Heading */}
      <div className="flex flex-col items-center mb-6">
        <img src={logo} alt="Load App Logo" className="mb-2 w-28" />
        <h2 className="text-gray-700 text-lg font-medium text-center">Reset Your Password</h2>
        <p className="text-sm text-gray-500 text-center mt-1">Enter your email and we’ll send you a link to reset your password.</p>
      </div>

      {/* Messages */}
      {successMessage && <div className="mb-4 text-green-600 text-center font-medium bg-green-50 p-2 rounded border border-green-200">{successMessage}</div>}
      {errorMessage && <div className="mb-4 text-red-600 text-center font-medium bg-red-50 p-2 rounded border border-red-200">{errorMessage}</div>}

      {/* Form */}
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label className="block text-sm font-medium text-gray-700">Email Address</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 block w-full rounded-lg border border-gray-300 bg-white text-gray-900 shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter your email" />
        </div>

        <button type="submit" disabled={loading} className="cursor-pointer w-full py-2 px-4 text-white rounded-lg bg-blue-600 hover:bg-blue-700 transition flex items-center justify-center gap-2 disabled:opacity-50">
          {loading && <LoaderCircle className="animate-spin w-4 h-4" />}
          Send Reset Link
        </button>
      </form>

      {/* Back to Login */}
      <div className="mt-6 text-center">
        <p className="text-sm text-gray-600">
          Remember your password?{' '}
          <Link to="/auth/login" className="text-blue-600 hover:underline font-medium">
            Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
}
